import { carbonMenuItems } from "@/layouts/carbon/carbon-menu-items";
import { Roles } from "../types/Users";
import { routes } from "@/config/routes";

export function findAccessiblePath(currentRole?: Roles): string | null {
  if (!currentRole) return null;

  if (currentRole === Roles.ADMIN || currentRole === Roles.AGENCY)
    return routes.home; // default path for admin and agency

  const accessibleTab = carbonMenuItems.find((item) =>
    item.permissions?.includes(currentRole)
  );

  if (!accessibleTab || !accessibleTab?.href) return null;

  return accessibleTab.href;
}
